export const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

export function findAllTabbableElement (domElement) {
  return [...domElement.querySelectorAll(focusableSelector)]
    .filter(node => !node.disabled);
}
export function findFirstTabbableElement (domElement) {
  const found = findAllTabbableElement(domElement);
  return found[0];
}

export function findLastTabbableElement (domElement) {
  const found = findAllTabbableElement(domElement);
  return found[found.length - 1];
}

export function isChildInsideWrapper (child, wrapper) {
  for(let element = child; element; element = element.parentElement) {
    if (element === wrapper) {
      return true;
    }
  }

  return false;
}
